module.exports = __webpack_public_path__ + "static/media/tabbargetfans_S.7386f44d.png";